/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ExternalSystemEnum = {
    Doctolib: 'DOCTOLIB'
} as const;
export type ExternalSystemEnum = typeof ExternalSystemEnum[keyof typeof ExternalSystemEnum];

